/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Vuex from "vuex";
import stores from "./stores";

export default new Vuex.Store({
  modules: {
    ...stores
  }
});
